import { List } from 'immutable';

import State from '../core/State';
import GoogleAdAccount from '../entity/GoogleAdAccount';
import initialState from '../initialState';

export const setGoogleAdAccounts = (googleAdAccounts: List<GoogleAdAccount>) => (state: State): State => ({
  ...state,
  googleAdAccounts,
});

export const startIntegratedGoogleAdAccounts = () => (state: State): State => ({
  ...state,
  integratedGoogleAdAccounts: {
    ...state.integratedGoogleAdAccounts,
    fetching: state.integratedGoogleAdAccounts.fetching + 1,
  },
});

export const setIntegratedGoogleAdAccounts = (integratedGoogleAdAccounts: List<GoogleAdAccount>) => (
  state: State,
): State => ({
  ...state,
  integratedGoogleAdAccounts: {
    adAccounts: integratedGoogleAdAccounts,
    fetching: state.integratedGoogleAdAccounts.fetching - 1,
  },
});

export const finishIntegratedGoogleCommunication = () => (state: State): State => ({
  ...state,
  integratedGoogleAdAccounts: {
    ...state.integratedGoogleAdAccounts,
    fetching: state.integratedGoogleAdAccounts.fetching - 1,
  },
});

export const disposeGoogleAdAccounts = () => (state: State): State => ({
  ...state,
  googleAdAccounts: initialState.googleAdAccounts,
});
